<template>
  <v-list-item-content>
    <v-list-item-title v-html="markText(searchText, name)" />
    <v-list-item-subtitle
      v-if="attrs"
      v-html="markText(searchText, attrs.join(' || '))"
    />
  </v-list-item-content>
</template>

<script>
import { markText } from "@/utils/pureFunctions";

export default {
  name: "product-select-item",
  props: ["name", "searchText", "attrs"],
  methods: {
    markText,
  },
};
</script>
